<form [formGroup]="formGroup">
  <wz-button-toggle
    enumItemsKey="CIVILITY_ENUM"
    formControlName="civilite"
    orientation="row"
    title="Civilité *"
    class="civility-toggle-button"
  >
  </wz-button-toggle>
  <mat-error *ngIf="civiliteCtrl.dirty && civiliteCtrl.hasError('required')"
    >La civilité doit être renseignée
  </mat-error>
  <div class="controls mt-8">
    <mat-form-field>
      <wz-text-input placeholder="Nom" formControlName="nom"></wz-text-input>
      <mat-error
        *ngIf="nomCtrl.hasError('required')"
        wzI18n="FORMS_LASTNAME_REQUIRED"
      ></mat-error>
      <mat-error
        *ngIf="nomCtrl.hasError('pattern')"
        wzI18n="FORMS_LASTNAME_PATTERN"
      ></mat-error>
    </mat-form-field>
    <mat-form-field>
      <wz-text-input
        placeholder="Prénom"
        formControlName="prenom"
      ></wz-text-input>
      <mat-error
        *ngIf="prenomCtrl.hasError('required')"
        wzI18n="FORMS_FIRSTNAME_REQUIRED"
      ></mat-error>
      <mat-error
        *ngIf="prenomCtrl.hasError('pattern')"
        wzI18n="FORMS_FIRSTNAME_PATTERN"
      ></mat-error>
    </mat-form-field>
  </div>
  <wz-address-picker
    [addressRepository]="addressRepository"
    [config]="config.address"
    formControlName="address"
    [isAlreadyFullAddress]="true"
  ></wz-address-picker>
  <mat-form-field>
    <wz-mail-input placeholder="Email" formControlName="email"></wz-mail-input>
    <mat-error
      *ngIf="emailCtrl.hasError('required')"
      wzI18n="FORMS_EMAIL_REQUIRED"
    ></mat-error>
    <mat-error
      *ngIf="emailCtrl.hasError('pattern')"
      wzI18n="FORMS_EMAIL_PATTERN"
    ></mat-error>
    <mat-error *ngIf="emailCtrl.hasError('mailBroker')"
      >L'adresse email doit être différent de celle de l'agence'.
    </mat-error>
  </mat-form-field>
  <div class="controls">
    <mat-form-field>
      <wz-phone-input
        phoneKind="mobile"
        placeholder="Téléphone portable"
        formControlName="mobile"
      >
      </wz-phone-input>
      <mat-error
        *ngIf="mobileCtrl.hasError('pattern')"
        wzI18n="FORMS_MOBILE_PATTERN"
      ></mat-error>
      <mat-error
        *ngIf="formGroup.hasError('atleastonerequired')"
        wzI18n="FORMS_PHONE_ATLEASTONE_REQUIRED"
      >
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <wz-phone-input
        phoneKind="localPhone"
        placeholder="Téléphone fixe"
        formControlName="phone"
      >
      </wz-phone-input>
      <mat-error
        *ngIf="phoneCtrl.hasError('pattern')"
        wzI18n="FORMS_PHONE_PATTERN"
      ></mat-error>
      <mat-error
        *ngIf="formGroup.hasError('atleastonerequired')"
        wzI18n="FORMS_PHONE_ATLEASTONE_REQUIRED"
      >
      </mat-error>
      <mat-hint *ngIf="!phoneCtrl.value && !mobileCtrl.value"
        >Saisir au moins un numéro de téléphone</mat-hint
      >
    </mat-form-field>
  </div>

  <ng-content></ng-content>

  <span class="warn" *ngIf="!forTunnelApp">
    (Wazari s'engage à ne pas utiliser ces données à des fins commerciales)
  </span>
</form>
